import { Directive, ViewContainerRef, inject, effect, ComponentRef, OnDestroy } from '@angular/core';
import { TokenRefreshService } from '@outlaw/core';
import { RefreshProgressBarComponent } from '../components/refresh-progress-bar/refresh-progress-bar.component';

@Directive({
  selector: '[ol-refresh-progress]',
})
export class RefreshProgressDirective implements OnDestroy {
  private viewContainer = inject(ViewContainerRef);
  private tokenRefreshService = inject(TokenRefreshService);
  private componentRef: ComponentRef<RefreshProgressBarComponent> | null = null;

  constructor() {
    effect(() => {
      const isVisible = this.tokenRefreshService.isVisible();

      if (isVisible && !this.componentRef) {
        this.componentRef = this.viewContainer.createComponent(RefreshProgressBarComponent);
      } else if (!isVisible && this.componentRef) {
        this.componentRef.destroy();
        this.componentRef = null;
        this.viewContainer.clear();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
      this.viewContainer.clear();
    }
  }
}
